module.exports = __webpack_public_path__ + "img/vertical_5_1_8003.456cbdd5.png";